import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSentimentVeryPositive = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 25 25",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M21.0508 12.2783C21.0508 17.2489 17.0213 21.2783 12.0508 21.2783C7.08022 21.2783 3.05078 17.2489 3.05078 12.2783C3.05078 7.30776 7.08022 3.27832 12.0508 3.27832C17.0213 3.27832 21.0508 7.30776 21.0508 12.2783Z",
			stroke: "currentColor",
			strokeWidth: 1.5,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M16.886 14.8151H7.21558C7.90697 16.0087 10.003 17.7043 12.0481 17.7043C14.0932 17.7043 16.6606 16.0804 16.886 14.8151Z",
			fill: "currentColor",
			stroke: "currentColor",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M7.09912 11.0476C7.09912 11.0476 7.64346 9.41484 8.65948 9.41484C9.67551 9.41484 10.2198 11.0476 10.2198 11.0476",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M13.6552 11.0476C13.6552 11.0476 14.1995 9.41484 15.2155 9.41484C16.2315 9.41484 16.7759 11.0476 16.7759 11.0476",
			stroke: "currentColor",
			strokeWidth: 1.2,
			strokeLinecap: "round",
			strokeLinejoin: "round"
		})
	]
});
export default SvgSentimentVeryPositive;
